export default __webpack_public_path__ + "static/media/wrench-solid.62811a14.svg";